import { render, staticRenderFns } from "./vlist.vue?vue&type=template&id=fdbc2044&scoped=true"
import script from "./vlist.vue?vue&type=script&lang=js"
export * from "./vlist.vue?vue&type=script&lang=js"
import style0 from "./vlist.vue?vue&type=style&index=0&id=fdbc2044&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbc2044",
  null
  
)

export default component.exports